import { render } from "./VIPManage.vue?vue&type=template&id=75354ade&scoped=true"
import script from "./VIPManage.vue?vue&type=script&lang=js"
export * from "./VIPManage.vue?vue&type=script&lang=js"

import "./VIPManage.vue?vue&type=style&index=0&id=75354ade&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75354ade"]])

export default __exports__